import { Tag } from "@/Components/Tag";
import { LogIn, MoreVertical } from "react-feather";
import { ActionMenu } from "@/Components/ActionMenu";
import React, { useCallback, useMemo, useRef, useState } from "react";
import { Inertia } from "@inertiajs/inertia";
import { toast } from "react-toastify";
import { Dialog } from "@/Components";
import { showToast } from "@/Utilities/Utilities";
import AgencyDialogCenter from "@/Pages/Superuser/Agencies/Partials/AgencyDialogCenter";

const AgencyRow = ({ organization }) => {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showInactivateModal, setShowInactivateModal] = useState(false);

  const handleUnlock = useCallback(() => {
    const id = toast.loading("Please wait...");
    Inertia.put(route("admin.agencies.unlock", organization.id), null, {
      onSuccess: () => showToast(id, "The account was successfully restored"),
      onError: () =>
        showToast(
          id,
          "Something went wrong when restoring the account",
          "error",
        ),
    });
  }, [organization.id]);

  const actionMenuItems = useMemo(() => {
    if (!organization.locked_at) {
      return [
        {
          label: "Edit client",
          callback: () =>
            Inertia.visit(route("admin.agencies.edit", organization.id)),
        },
        {
          label: "Login on account",
          callback: () =>
            Inertia.put(route("admin.organizations.view", organization.id)),
        },
        {
          label: "Inactivate",
          callback: () => setShowInactivateModal(true),
        },
        {
          label: "Delete",
          callback: () => setShowDeleteModal(true),
        },
      ];
    } else {
      return [
        {
          label: "Reactivate",
          callback: () => handleUnlock(),
        },
        {
          label: "Delete",
          callback: () => setShowDeleteModal(true),
        },
      ];
    }
  }, [organization.locked_at, handleUnlock]);

  const actionMenuRef = useRef(null);

  return (
    <>
      <div className="shadow-small grid-rows-[repeat(2, auto)] mb-2 grid min-h-[53px] grid-cols-4 gap-2 bg-gray-light p-4 md:grid-flow-col-dense md:grid-cols-12 md:grid-rows-1 md:p-8 md:px-4 md:py-2">
        <div className="col-span-3 flex items-center md:col-span-9">
          <h3 className={`truncate font-bold leading-none`}>
            {organization.name}{" "}
            <span className="font-normal">
              {organization.organization_number}
            </span>
          </h3>
        </div>
        <div className="col-span-4 flex items-center justify-end md:col-span-2">
          <div className="flex shrink-0 items-start gap-4">
            <button
              className="flex items-end gap-2 text-primary underline hover:no-underline"
              onClick={() =>
                Inertia.put(route("admin.organizations.view", organization.id))
              }
            >
              <LogIn size={24} />
              Switch to
            </button>
          </div>
        </div>
        <div className="col-span-1 col-start-4 row-start-1 flex items-center justify-end md:col-start-12">
          <div className="hover-circle relative z-10 ml-2">
            <MoreVertical
              size={24}
              className="shrink-0 cursor-pointer"
              onClick={(e) => {
                e.preventDefault();
                actionMenuRef.current.toggleMenu();
              }}
            />
            <ActionMenu ref={actionMenuRef} items={actionMenuItems} />
          </div>
        </div>
      </div>

      <AgencyDialogCenter
        organization={organization}
        showDeleteModal={showDeleteModal}
        setShowDeleteModal={setShowDeleteModal}
        showInactivateModal={showInactivateModal}
        setShowInactivateModal={setShowInactivateModal}
      />
    </>
  );
};

export default AgencyRow;
